import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import EnergyValues from './EnergyValues'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { UnitTypes } from 'src/Libs/types'

const useStyles = makeStyles()(theme => ({
  cardContainer: {
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.grey.grey07,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.shades.shade03}`,
  },
  valueContainer: {
    marginTop: theme.spacing(1),
  },
}))

interface EnergyCardProps {
  title: string
  energyAll: number[]
}

const EnergyCard: React.FC<EnergyCardProps> = ({ title, energyAll }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Box className={classes.cardContainer}>
      <Typography variant={'h3'}>{title}</Typography>
      <Stack className={classes.valueContainer} direction={{ xs: 'column', md: 'row' }} spacing={2}>
        {energyAll.map((energy, idx) => (
          <EnergyValues
            key={`${energy}-${idx}`}
            title={`${t('systemSettings.solar.settings.phase', { index: idx + 1 })}`}
            value={energy}
            unit={UnitTypes.kiloWattHour}
          />
        ))}
      </Stack>
    </Box>
  )
}

export default EnergyCard
